import type { ActivePrivateLessonPackageDTO } from "@/modules/students/domain/repo/active-package.dto";
import { multiMemberPackageLabel } from "./package-kind";

type ActivePrivateLessonPackageRow = NonNullable<ActivePrivateLessonPackageDTO>;

/** ข้อความสมาชิกในแพ็กร่วม (group / private_shared) */
export function activePrivateLessonSharedMembershipLabel(
  pkg: Pick<
    ActivePrivateLessonPackageRow,
    "membershipRole" | "ownerStudentName" | "packageKind"
  >,
): string | null {
  if (pkg.membershipRole !== "member") return null;
  const kindLabel = multiMemberPackageLabel(pkg.packageKind) ?? "ແພັກເກດຮ່ວມ";
  const owner = pkg.ownerStudentName?.trim();
  return owner
    ? `ສະມາຊິກ ${kindLabel} · ຜູ້ຈ່າຍ ${owner}`
    : `ສະມາຊິກ ${kindLabel}`;
}

/** สำหรับ dropdown / สรุปสั้น ๆ */
export function activePrivateLessonPackageOptionSuffix(
  pkg: Pick<
    ActivePrivateLessonPackageRow,
    "membershipRole" | "ownerStudentName"
  >,
): string {
  if (pkg.membershipRole !== "member") return "";
  const owner = pkg.ownerStudentName?.trim();
  return owner ? ` · ຮ່ວມ (${owner})` : " · ຮ່ວມ";
}
